import helpers from '../helpers.js';
let imgSlider = {
    init: () => {
        const imgSliders = document.querySelectorAll('.js-img-slider');

        const toggleButtons = (imgSlider) => {
            const index = parseInt(imgSlider.dataset.index);
            const count = parseInt(imgSlider.dataset.count) - 1;
            const prevBtn = imgSlider.querySelector('.js-prev');
            const nextBtn = imgSlider.querySelector('.js-next');

            if (index <= 0) {
                prevBtn.style.display = "none";
            } else {
                prevBtn.style.removeProperty('display');
            }

            if (index < count) {
                nextBtn.style.removeProperty('display');
            } else {
                nextBtn.style.display = "none";
            }
        }


        const showStartingImage = (imgSlider) => {
            const wrapper = imgSlider.querySelector('.js-wrapper');
            const scrollElement = wrapper.children[0];
            if (scrollElement)
                scrollElement.scrollIntoView({ behavior: "instant", block: "nearest" });
        }

        const showPreviousImage = (imgSlider) => {
            return () => {
                const index = parseInt(imgSlider.dataset.index) - 1;
                const wrapper = imgSlider.querySelector('.js-wrapper');
                const scrollElement = wrapper.children[index];
                if (scrollElement)
                    scrollElement.scrollIntoView({ behavior: "smooth", block: "nearest" });
            }
        }

        const showNextImage = (imgSlider) => {
            return () => {
                const index = parseInt(imgSlider.dataset.index) + 1;
                const wrapper = imgSlider.querySelector('.js-wrapper');
                const scrollElement = wrapper.children[index];
                if (scrollElement)
                    scrollElement.scrollIntoView({ behavior: "smooth", block: "nearest" });
            }
        }

        const setIndexOnScroll = (imgSlider, scrollWrapper) => {
            const newIndex = Math.floor(scrollWrapper.scrollLeft / scrollWrapper.offsetWidth);
            imgSlider.dataset.index = newIndex;
            if (imgSlider.dataset.gallery)
                imgSlider.querySelector('.js-gallery-index').innerText = newIndex + 1;
            toggleButtons(imgSlider);
        };

        // Gallery functions
        const closeOverview = (gallery) => {
            return () => {
                if (gallery.classList.contains('lightbox')) {
                    gallery.classList.remove('lightbox');
                } else {
                    gallery.classList.remove('active');
                    gallery.dataset.index = 0;
                    // Timeout to let CSS animation finish
                    setTimeout(() => {
                        document.body.classList.remove('modal-active');
                    }, 300)
                }
            }
        }

        const showOverview = (gallery) => {
            return () => {
                gallery.classList.add('active');
                document.body.classList.add('modal-active');
            }
        }

        const viewImage = (gallery) => {
            return (e) => {
                const wrapper = gallery.querySelector('.js-wrapper');
                const scrollElement = wrapper.children[e.target.dataset.index];
                if (scrollElement) {
                    gallery.classList.add('lightbox');
                    scrollElement.scrollIntoView({ block: "start" });
                    gallery.querySelector('.js-gallery-index').innerText = parseInt(e.target.dataset.index + 1);
                }
            }
        }

        if (imgSliders) {
            imgSliders.forEach((imgSlider) => {
                const prevBtn = imgSlider.querySelector('.js-prev');
                if (prevBtn)
                    prevBtn.addEventListener('click', showPreviousImage(imgSlider));

                const nextBtn = imgSlider.querySelector('.js-next');
                if (nextBtn)
                    nextBtn.addEventListener('click', showNextImage(imgSlider));

                const scrollWrapper = imgSlider.querySelector('.js-scroll-wrapper');
                if (scrollWrapper)
                    scrollWrapper.addEventListener('scroll', helpers.debounce(() => { setIndexOnScroll(imgSlider, scrollWrapper) }, 10)), { passive: true };

                if (imgSlider.dataset.gallery) {
                    const openBtn = imgSlider.querySelector('.js-open-gallery');
                    if (openBtn)
                        openBtn.addEventListener('click', showOverview(imgSlider));

                    const openGalleryPreviewLarge = imgSlider.querySelector('.preview-large');
                    if (openGalleryPreviewLarge)
                        openGalleryPreviewLarge.addEventListener('click', showOverview(imgSlider));

                    const openGalleryPreviewSmall = imgSlider.querySelector('.preview-small');
                    if (openGalleryPreviewSmall)
                        openGalleryPreviewSmall.addEventListener('click', showOverview(imgSlider));


                    const closeBtns = imgSlider.querySelectorAll('.js-close-gallery');
                    if (closeBtns) {
                        for (const btn of closeBtns) {
                            btn.addEventListener('click', closeOverview(imgSlider));
                        }
                    }

                    const imageBtns = imgSlider.querySelectorAll('.js-view-image');
                    if (imageBtns)
                        imageBtns.forEach(btn => btn.addEventListener('click', viewImage(imgSlider)));
                }
                 
                showStartingImage(imgSlider); //Firefow fix
                toggleButtons(imgSlider);
            });
        }
    }
}

export default imgSlider;